module.exports = __webpack_public_path__ + "media/images/landkit/illustrations/illustration-9-a405404c8e8dfda8a032eaec9fc25aae.png";